const actions = {
    GET_CLIENT_OWNER: 'client/GET_CLIENT_OWNER',
    SET_CLIENT_OWNER: 'client/SET_CLIENT_OWNER',

    SET_INIT_CLIENT_OWNER: 'client/SET_INIT_CLIENT_OWNER',

    SET_INITIAL_OWNER: "client/SET_INITIAL_OWNER"
};

export default actions